export function getEnvironment(hostname = window.location.hostname, configured = process.env.REACT_APP_ENV) {
    const host = hostname.toLowerCase().replace(/:\d+$/, "").replace(/\.$/, "");
    if (host === "yellgo.test" || host.endsWith(".yellgo.test") || configured === "pi") return "pi";
    if (configured === "localhost") return "localhost";
    if (host === "localhost" || host.includes(".localhost") || host.includes(".dev.")) return "dev";
    return "prod";
}

export function getApiUrl(env = getEnvironment()) {
    if (env === "pi") return "http://api.yellgo.test";
    if (env === "localhost") return "http://api.sdm.localhost";
    return env === "dev" ? "https://api.dev.yellgo.cloud" : "https://api.yellgo.cloud";
}

export function getSocketUrl(env = getEnvironment()) {
    if (env === "pi") return "http://socket.yellgo.test";
    return env === "localhost" || env === "dev" ? "https://ws.dev.yellgo.cloud:3000" : "https://ws.yellgo.cloud";
}

export function getSocketMandantId(id, env = getEnvironment()) {
    if (!id) return id;
    return env === "pi" || env === "localhost" ? `${id}_${env}` : id;
}
